import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=0d1b7b72&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&lang=ts"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=0d1b7b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1b7b72",
  null
  
)

export default component.exports